export default "__VITE_ASSET__HEe966ij__"